import { useEffect, useState } from "react"
import { useNavigate, useSearchParams } from "react-router-dom"
import { HealthPlanPdfType } from "../../../utils/api-objects/HealthPlan"
import { getHealthPlanPdf } from "../../../utils/apis/plan-service"
import { useAuthStore } from "../../../utils/stores/useAuthStore"
import LoadingSpinner from "../../shared/components/Loaders"
import { useGetHealthPlan } from "../hooks/useGetHealthPlan"
import { HealthPlanDataBox } from "./HealthPlanCard"

const OldHealthPlan = () => {
    const { auth } = useAuthStore()
    const idToken = auth.idToken
    const userId = auth.userId
    // const { plans } = usePlansStore()
    // const healthPlans = plans.healthPlans
    const {healthPlans} = useGetHealthPlan()
    const [searchParams] = useSearchParams()
    const healthPlanId = searchParams.get("id")
    const spanDate = searchParams.get("span-date")

    const navigate = useNavigate()

    const currentHealthPlan = healthPlans ? healthPlans.filter(hp => hp.id === healthPlanId)[0] : null

    const [isLoading, setIsLoading] = useState(false)

    const [pdfs, setPdfs] = useState<{
        type: HealthPlanPdfType,
        filename: string
        url: string
        uploaded_at: string
    }[]>([]);

    useEffect(() => {
        const fetchPdfs = async () => {
            if (!userId || !idToken) return;

            setIsLoading(true);
            setPdfs([]); // Clear previous data before fetching

            try {
                const [materials, prescriptions] = await Promise.all([
                    getHealthPlanPdf(userId, idToken, `${healthPlanId}/${HealthPlanPdfType.Materials}`),
                    getHealthPlanPdf(userId, idToken, `${healthPlanId}/${HealthPlanPdfType.Prescriptions}`)
                ]);

                // Combine both results into a single array
                const pdfList = [
                    ...materials.map(pdf => ({
                        type: HealthPlanPdfType.Materials,
                        filename: pdf.filename,
                        url: pdf.url,
                        uploaded_at: pdf.uploaded_at,
                    })),
                    ...prescriptions.map(pdf => ({
                        type: HealthPlanPdfType.Prescriptions,
                        filename: pdf.filename,
                        url: pdf.url,
                        uploaded_at: pdf.uploaded_at,
                    }))
                ];

                setPdfs(pdfList); // Store all PDFs in one go
            } catch (error) {
                console.log(error);
            } finally {
                setIsLoading(false);
            }
        };

        fetchPdfs();
    }, []);

    if (!currentHealthPlan) {
        return <div>
            Health Plan non trovato
        </div>
    }

    if (isLoading) {
        return (
            <LoadingSpinner />
        )
    }

    return (
        <div className="w-full h-full flex flex-col max-w-[1068px]">
            <div className="space-y-[20px] flex flex-col">
                {/* <div className="flex justify-between items-start">
                    <div>
                        <div className="font-bold text-[20px] leading-[33px]">Health Plan passati</div>
                        <div className="font-bold text-[14px] leading-[33px]">{spanDate}</div>
                    </div>
                    <CloseButton onClick={() => navigate("/health-plan-history")} />
                </div> */}
                <div className="font-bold text-[14px] leading-[33px]">{spanDate}</div>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-[20px]">
                    {currentHealthPlan.data.comment && <HealthPlanDataBox title="👩‍⚕️‍  Commento del medico" data={currentHealthPlan.data.comment} source={"old_health_plan_page"}/>}
                    {currentHealthPlan.data.food_suggested && <HealthPlanDataBox title="🥙  Alimenti consigliati" data={currentHealthPlan.data.food_suggested.map(item => item.text)} source={"old_health_plan_page"}/>}
                    {currentHealthPlan.data.integrators_suggested && <HealthPlanDataBox title="💊  Integratori consigliati" data={currentHealthPlan.data.integrators_suggested.map(item => item.text)} source={"old_health_plan_page"}/>}
                    {currentHealthPlan.data.check_ups_suggested && <HealthPlanDataBox title="🩺  Check-up consigliati" data={currentHealthPlan.data.check_ups_suggested.map(item => item.text)} source={"old_health_plan_page"}/>}
                </div>
                {
                    currentHealthPlan.pdf_data.length > 0 &&
                    <div className="w-full flex flex-col md:flex-row space-y-[20px] md:space-y-0 md:space-x-[20px] pb-[20px]">
                        {
                            currentHealthPlan.pdf_data.some(pdf => pdf.type === HealthPlanPdfType.Materials) && (
                                <div className="flex-1 basis-1/2 min-w-0 h-fit rounded-[20px] bg-[#F5F5F5] p-[20px] space-y-[10px]">
                                    <div className="font-bold text-[16px] leading-[33px]">🗂️ Materiali di approfondimento</div>
                                    <div className="space-y-[10px]">
                                        {
                                            pdfs.map((pdf, index) => (
                                                pdf.type === HealthPlanPdfType.Materials &&
                                                <div
                                                    key={index}
                                                    className="rounded-[4px] font-normal text-[16px] leading-[33px] bg-[#E7E7E7] flex justify-between items-center p-[10px] space-x-[30px]"
                                                >
                                                    <div className="truncate" title={pdf.filename}>{pdf.filename}</div>
                                                    <div
                                                        className="font-bold text-[12px] leading-[17px] text-holifya-blue cursor-pointer"
                                                        onClick={() => window.open(pdf.url, "_blank")}
                                                    >
                                                        Scarica
                                                    </div>
                                                </div>
                                            ))
                                        }
                                    </div>
                                </div>
                            )
                        }
                        {
                            currentHealthPlan.pdf_data.some((pdf) => pdf.type === HealthPlanPdfType.Prescriptions) && (
                                <div className="flex-1 basis-1/2 min-w-0 h-fit rounded-[20px] bg-[#F5F5F5] p-[20px] space-y-[10px]">
                                    <div className="font-bold text-[16px] leading-[33px]">📄 Carica prescrizioni</div>
                                    <div className="space-y-[10px]">
                                        {
                                            pdfs.map((pdf, index) => (
                                                pdf.type === HealthPlanPdfType.Prescriptions &&
                                                <div
                                                    key={index}
                                                    className="rounded-[4px] font-normal text-[16px] leading-[33px] bg-[#E7E7E7] flex justify-between items-center p-[10px] space-x-[30px]"
                                                >
                                                    <div className="truncate" title={pdf.filename}>{pdf.filename}</div>
                                                    <div
                                                        className="font-bold text-[12px] leading-[17px] text-holifya-blue cursor-pointer"
                                                        onClick={() => window.open(pdf.url, "_blank")}
                                                    >
                                                        Scarica
                                                    </div>
                                                </div>
                                            ))
                                        }
                                    </div>
                                </div>
                            )
                        }
                    </div>
                }
            </div>
        </div>
    )
}

export default OldHealthPlan
